import React, { Component } from "react";

import "./form.scss";

class Form extends Component {
  render() {
    const { className, children, finalStep } = this.props;

    return (
      <div
        role="form"
        aria-label="Form"
        className={`form ${finalStep ? "form--final" : ""} ${
          className ? className : ""
        }`}
      >
        <div className="form__content">{children}</div>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/_common/Form/index.js